import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useDispatch, useSelector } from 'react-redux';
import {selectors, setFilterSubject} from '../../features/schools/slice';

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const subjectFilter = () => {

    const classes = useStyles();

    const filterSubject = useSelector(selectors.filterSubject);
    const filterYear = useSelector(selectors.filterYear);
    const dispatch = useDispatch();

    const handleChange = (event) => {
        history.replaceState({} , '', '/?subject=' + event.target.value.toLowerCase());
        dispatch(setFilterSubject(event.target.value));
    }

    let subjects = [
      <MenuItem value={'FIZ'}>Fizika</MenuItem>,
      <MenuItem value={'MAT'}>Matemātika</MenuItem>,
      <MenuItem value={'KIM'}>Ķīmija</MenuItem>
    ];

    if (filterYear == 2022) {
      subjects = [
        <MenuItem value={'FIZ'}>Fizika</MenuItem>,
        <MenuItem value={'MAT'}>Matemātika</MenuItem>,
        <MenuItem value={'MAT_opt'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Optimālais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'KIM'}>Ķīmija</MenuItem>
      ];
    }

    else if (filterYear > 2022 && filterYear < 2024) {
      subjects = [
        <MenuItem value={'FIZ'}>
          Fizika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'MAT'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'MAT_opt'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Optimālais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'KIM'}>
          Ķīmija <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
      ];
    }

    else if (filterYear == 2024) {
      subjects = [
        <MenuItem value={'FIZ'}>
          Fizika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'MAT'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'MAT_opt'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Optimālais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'MAT_visp'}>
          Matemātika <br />
          <sub style={{display: 'contents', color: 'gray'}}>Vispārīgais līmenis</sub>
        </MenuItem>,
        <MenuItem value={'KIM'}>
          Ķīmija <br />
          <sub style={{display: 'contents', color: 'gray'}}>Augstākais līmenis</sub>
        </MenuItem>,
      ];
    }
    
    return <FormControl className={classes.formControl}>
      <InputLabel id="subjectFilter">Mācību priekšmets</InputLabel>
      <Select
        labelId="subjectFilter-label"
        id="subjectFilter-helper"
        value={filterSubject}
        onChange={handleChange}
      >
        {subjects.map((subject) => (subject))}
      </Select>
      <FormHelperText>Izvēlieties mācību priekšmetu</FormHelperText>
    </FormControl>
}

export default subjectFilter;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/filters/subject.js